import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = ''
}) => {
    const baseStyles = 'inline-flex items-center justify-center gap-2 font-medium transition-all duration-300 active:scale-[0.98]';

    const variants = {
        primary: 'bg-[#2D6A4F] text-white hover:bg-[#1B4332] disabled:opacity-50 disabled:cursor-not-allowed',
        secondary: 'border border-[#2D6A4F] text-[#2D6A4F] hover:bg-[#2D6A4F] hover:text-white disabled:opacity-50',
        ghost: 'text-[#2D6A4F] hover:bg-[#F8FAF8]',
        link: 'text-[#2D6A4F] underline-offset-4 hover:underline px-0 py-0',
    };

    const sizes = {
        sm: 'px-4 py-2 text-sm',
        md: 'px-6 py-3 text-sm',
        lg: 'px-8 py-3.5 text-base',
    };

    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${widthClass} ${className}`}
            style={{ fontFamily: "'Poppins', sans-serif" }}
        >
            {children}
        </button>
    );
};

export default Button;
